/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Antsy_Plain_Tortoise_WalkInputs */

const fr_antsy_plain_tortoise_walk = /** @type {(inputs: Antsy_Plain_Tortoise_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune date d'expiration`)
};

/**

* @param {Antsy_Plain_Tortoise_WalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const antsy_plain_tortoise_walk = /** @type {((inputs?: Antsy_Plain_Tortoise_WalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Antsy_Plain_Tortoise_WalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_antsy_plain_tortoise_walk(inputs)
});